import { CustomInsightType } from '../../Monitor/Shared/models/custom-insights-type.model';

/**
 * Prompt type a curation agent runs on. Saving one has agents-service work out the curation
 * criteria behind it, which is what the agent evaluates each mention against - an agent only
 * accepts a prompt of a curator type, and this is the one coverage curation uses.
 */
export const curationPromptType: CustomInsightType = CustomInsightType.COVERAGE_CURATION;
